import routeHelper from 'components/shared/mixins/routeHelper'

export default {
    mixins: [routeHelper],
    computed: {
        getSubmitButtonStyles () {
            return {
                'submit': {
                    'container': {
                        'default': {
                            'backgroundColor': '#AAAAAA',
                            'border-radius': '20px',
                            'padding': '3px',
                            'margin': '0px 10px 5px 0px'
                        },
                        'hover': {
                            'margin-right': '10px'
                        },
                        'click': {
                            'backgroundColor': '#068e56',
                            'margin-right': '10px'
                        }
                    },
                    'svg': {
                        'content': '<?xml version="1.0" ?> <svg width="16" height="14" viewBox="0 0 16 14" fill="white" style="color: white; filter: none;" xmlns="http://www.w3.org/2000/svg"><path d="M1.57928 13.435L15.0317 7.70478C15.6561 7.43666 15.6561 6.56334 15.0317 6.29522L1.57928 0.565024C1.07047 0.342864 0.507709 0.718238 0.507709 1.26215L0.5 4.79372C0.5 5.17676 0.785237 5.50617 1.17069 5.55213L12.0637 7L1.17069 8.44021C0.785237 8.49383 0.5 8.82324 0.5 9.20628L0.507709 12.7379C0.507709 13.2818 1.07047 13.6571 1.57928 13.435Z" fill="white"/></svg>',
                        'styles': {
                            'default': {
                                'padding': '5px',
                                'color': 'white',
                                'width': '1.3em',
                            }
                        }
                    }
                },
                'loading': {
                    'container': {
                        'default': {
                            'backgroundColor': 'white'
                        }
                    },
                    'svg': {
                        'styles': {
                            'default': {
                                'filter': 'brightness(0) saturate(100%) invert(72%) sepia(0%) saturate(3044%) hue-rotate(322deg) brightness(100%) contrast(96%)'
                            }
                        }
                    }
                },
                'stop': {
                    'container': {
                        'default': {
                            'backgroundColor': 'white'
                        },
                        'hover': {
                            'backgroundColor': '#dadada52'
                        }
                    },
                    'svg': {
                        'content': '<?xml version="1.0" encoding="utf-8"?> <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"> <rect width="24" height="24" rx="4" ry="4" /> </svg>',
                        'styles': {
                            'default': {
                                'width': '0.95em',
                                'marginTop': '0.32em',
                                'filter': 'brightness(0) saturate(100%) invert(72%) sepia(0%) saturate(3044%) hue-rotate(322deg) brightness(100%) contrast(96%)' 
                            }
                        }
                    }
                }
            }
        },
        getMessageStyles () {
            if (this.isMobileSmallView) {
                return {
                    'default': {
                        'shared': {
                            'bubble': {
                                'font-family': 'Nunito-Regular, sans-serif',
                                'margin-top': '5px',
                            },
                            'innerContainer': {
                                'flex-direction': 'column'
                            }
                        },
                        'user': {
                            'bubble': {
                                'padding': '15px 15px 15px 15px',
                                'maxWidth': '100%',
                                'backgroundColor': '#eeeeee',
                                'fontSize': '1.2rem',
                                'color': 'black',
                                'border-radius': '10px 0px 10px 10px',
                                'margin-top': '15px'
                            }
                        },
                        'ai': {
                            'bubble': {
                                'padding': '15px 15px 10px 15px',
                                'maxWidth': '100%',
                                'backgroundColor': '#FAE4CC',
                                'fontSize': '1.2rem',
                                'border-radius': '0px 10px 10px 10px',
                                'margin': '0 0 0 30px'
                            },
                            'innerContainer': {
                                'position': 'relative'
                            }
                        },
                        'suggestion': {
                            'bubble': {
                                'padding': '15px 15px 10px 15px',
                                'maxWidth': '100%',
                                'backgroundColor': '#FAE4CC',
                                'fontSize': '1.2rem',
                                'border-radius': '0px 10px 10px 10px',
                                'margin-left': 'auto',
                                'margin-right': 'auto',
                                'max-width': '100%',
                                'margin': '0 0 0 30px'
                            }
                        }
                    },
                    'loading': {
                        'bubble': {
                            'width': 'max-content !important',
                            'padding': '15px 15px 15px 20px',
                            'maxWidth': '100%',
                            'backgroundColor': '#FAE4CC',
                            'fontSize': '1.2rem',
                            'border-radius': '0px 10px 10px 10px',
                            'margin': '0 0 0 30px'
                        },
                        'innerContainer': {
                            'position': 'relative'
                        }
                    },
                    'error': {
                        'bubble': {
                            'padding': '15px 15px 15px 20px',
                            'maxWidth': '100%',
                            'fontSize': '1.2rem'
                        }
                    }
                }
            } else {
                return {
                    'default': {
                        'shared': {
                            'bubble': {
                                'font-family': 'Nunito-Regular, sans-serif',
                                'margin-top': '5px',
                            },
                            'innerContainer': {
                                'flex-direction': 'column'
                            }
                        },
                        'user': {
                            'bubble': {
                                'padding': '15px 15px 15px 15px',
                                'maxWidth': '100%',
                                'backgroundColor': '#dddddd',
                                'fontSize': '1.4rem',
                                'color': 'black',
                                'border-radius': '10px 0px 10px 10px',
                                'margin-top': '15px'
                            }
                        },
                        'ai': {
                            'bubble': {
                                'padding': '15px 15px 10px 15px',
                                'maxWidth': '100%',
                                'backgroundColor': '#FAE4CC',
                                'fontSize': '1.4rem',
                                'border-radius': '0px 10px 10px 10px',
                                'margin': '0 0 0 30px'
                            },
                            'innerContainer': {
                                'position': 'relative'
                            }
                        },
                        'suggestion': {
                            'bubble': {
                                'padding': '15px 15px 10px 15px',
                                'maxWidth': '100%',
                                'backgroundColor': '#FAE4CC',
                                'fontSize': '1.4rem',
                                'border-radius': '0px 10px 10px 10px',
                                'margin-left': 'auto',
                                'margin-right': 'auto',
                                'max-width': '100%',
                                'margin': '0 0 0 30px'
                            }
                        }
                    },
                    'loading': {
                        'bubble': {
                            'width': 'max-content !important',
                            'padding': '15px 15px 15px 20px',
                            'maxWidth': '100%',
                            'backgroundColor': '#FAE4CC',
                            'fontSize': '1.4rem',
                            'border-radius': '0px 10px 10px 10px',
                            'margin': '0 0 0 30px'
                        },
                        'innerContainer': {
                            'position': 'relative'
                        }
                    },
                    'error': {
                        'bubble': {
                            'color': 'black',
                            'backgroundColor': 'rgb(244, 192, 192)',
                            'borderRadius': '10px',
                            'margin-top': '15px',
                            'padding': '15px 15px 15px 20px',
                            'maxWidth': '100%',
                            'fontSize': '1.4rem'
                        }
                    }
                }
            }
        },
        getInputAreaStyles () {
            return {
                'fontSize': '1.4rem',
                'background': '#f8f8f8f8'
            }
        },
        getNameSettings () {
            return {
                'default': {
                    'style': {
                        'fontSize': '1.1rem',
                        'color': '#666666',
                        'fontFamily': 'Nunito-Bold, sans-serif'
                    }
                },
                'ai': {
                    'text': 'EVA',
                    'position': 'left',
                    'style': {
                        'margin': '18px 0px 0px 0px',
                        'color': '#666666',
                        'position': 'absolute',
                        'top': '6px',
                        'left': '33px',
                    }
                },
                'suggestion': {
                    'text': 'EVA',
                    'position': 'left'
                },
                'user': {
                    'text': 'You:',
                    'position': 'left',
                    'style': {
                        'display': 'none',
                        'justify-content': 'flex-end',
                        'margin-right': '0px',
                    }
                },
                'error': {
                    'style': {
                        'display': 'none',
                    }
                }
            }
        },
        getTextInputSettings () {
            return {
                'styles': {
                    'container': {
                        'borderRadius': '20px',
                        'border': 'solid 1px #888888',
                        'width': '90%',
                        'boxShadow': 'unset',
                        'fontSize': '16px'
                    },
                    'text': {
                        'padding': '10px',
                        'paddingLeft': '15px',
                        'paddingRight': '34px'
                    }
                },
                'placeholder': {
                    'text': this.$t('Chatbot.inputbox_placeholder_label'),
                    'style': {
                        'color': '#767676'
                    }
                }
            }
        },
        getHtmlClassUtilities () {
            return {
                'course-link': {
                    styles: {
                        default: {
                            borderRadius: '20px',
                            padding: '4px 13px',
                            color: '#000000',
                            backgroundColor: '#ffffff',
                            textDecoration: 'none',
                            border: 'solid 1px #C65300',
                            display: 'inline-flex',
                            fontFamily: 'Nunito-Regular, sans-serif',
                            cursor: 'pointer',
                            alignItems: 'center',
                            margin: '5px 0'
                        }
                    },
                    events: { click: (event) => this.handleCourseLinkClick(event) },
                },
                'learningpath-link': {
                    styles: {
                        default: {
                            borderRadius: '20px',
                            padding: '4px 13px',
                            color: '#000000',
                            backgroundColor: '#ffffff',
                            textDecoration: 'none',
                            border: 'solid 1px #C65300',
                            display: 'inline-flex',
                            fontFamily: 'Nunito-Regular, sans-serif',
                            cursor: 'pointer',
                            alignItems: 'center',
                            margin: '5px 0'
                        }
                    },
                    events: { click: (event) => this.handleLearningPathLinkClick(event) },
                },
                'course-link-text': {
                    styles: {
                        default: {
                            lineHeight: '19px'
                        }
                    }
                },
                'course-link-icon': {
                    styles: {
                        default: {
                            margin: '0px 5px 0px 0px',
                            height: '17px'
                        }
                    }
                },
                'suggestion-icon-link': {
                    styles: {
                        default: {
                            margin: '3px 0px 3px 10px',
                            height: '14px',
                            fontSize: '1rem'
                        }
                    }
                },
                'feedback-container-history': {
                    styles: {
                        default: {
                            justifyContent: 'flex-end',
                            gap: '7px',
                            display: 'flex'
                        }
                    }
                },
                'message': {
                    styles: {
                        default: {
                            whiteSpace: 'pre-line',
                            height: 'inherit',
                            display: 'flex'
                        }
                    }
                },
                'suggestion-buttons': {
                    styles: {
                        default: {
                            justifyContent: 'center'
                        }
                    }
                },
                'feedback-icon': {
                    styles: {
                        default: {
                            'margin': '15px 0 0',
                            'transition': 'opacity 0.3s',
                            'opacity': '1',
                            'padding': '8px 12px',
                            'backgroundColor': '#F4C999',
                            'border-radius': '5px'
                        },
                        hover: {
                            'cursor': 'pointer',
                            'backgroundColor': '#efad66'
                        }
                    },
                    events: { click: (event) => this.handleFeedbackClick(event) }
                },
                'feedback-text': {
                    styles: {
                        default: {
                            'display': 'flex',
                            'margin': '17px 0px 0px',
                            'align-items': 'center'
                        }
                    }
                },
                'feedback-icon-sent-history': {
                    styles: {
                        default: {
                            'background': '#EFAD66',
                            'margin': '10px 0px 0px',
                            'padding': '8px 12px',
                            'border-radius': '5px'
                        }
                    }
                },
                'error-message': {
                    styles: {
                        default: {
                            'padding': '10px',
                            'borderRadius': '10px',
                            'display': 'flex',
                        }
                    }
                },
                'deep-chat-suggestion-button': {
                    styles: {
                        default: {
                            'color': '#000000',
                            'border': '1px solid #C65300',
                            'cursor': 'pointer',
                            'fontFamily': 'Nunito-Regular, sans-serif',
                            'fontSize': '1.2rem',
                            'display': 'flex',
                            'alignItems': 'center',
                            'justifyContent': 'center',
                            'margin': '5px 0',
                            'text-align': 'left',
                            'transition': 'background-color 0.3s ease'
                        },
                        hover: {
                            'backgroundColor': '#efad66'
                        }
                    }
                }
            }
        },
        getAvatars () {
            return {
                'default': {
                    'styles': {
                        'avatar': {
                            'height': '25px', 'width': '35px'
                        },
                        'container': {
                            'marginTop': '8px'
                        }
                    }
                },
                'ai': {
                    'src': `${this.evaAvatar}`,
                    'styles': {
                        'avatar': {
                            'margin': '5px -10px'
                        }
                    }
                },
                'user': {
                    'styles': {
                        'avatar': {
                            'marginLeft': '-3px',
                            'display': 'none'
                        }
                    }
                }
            }
        },
        getGeneralStyles () {
            if (this.isMobileSmallView) {
                return `border: 0; width: 100%; height: 100%; px; background-color: #f8f8f8; opacity: 1;`
            } else {
                return 'border: 0; width: 100%; height: 100%; background-color: #f8f8f8; opacity: 1;'
            }
        }
    },
    methods: {
        async handleCourseLinkClick (event) {
            const course = await this.$store.dispatch('Courses/loadCourseWithId', event.target.id)
            this.$router.push(this.getRouteToCourse(course))
            if (this.isMobileSmallView) {
                this.closeChatbot()
            }
        },
        async handleLearningPathLinkClick (event) {
            const learningPath = await this.$store.dispatch('LearningPaths/getSingleLearningPathWithId', event.target.id)
            this.$router.push(this.getRouteToLearningPath(learningPath.slug))
            if (this.isMobileSmallView) {
                this.closeChatbot()
            }
        }
    }
}
